import { DashboardPeriodPreset, IVisitPeriod } from "../types/ownerDashboard.types";
import { getAllTimePeriod } from "./getAllTimePeriod";

export interface OwnerVisitsQuery {
  periodPreset: DashboardPeriodPreset;
  customPeriod?: IVisitPeriod | null;
  propertyId?: number | null;
  historyYears?: number;
  pastPage?: number;
  pastPerPage?: number;
  upcomingPage?: number;
  upcomingPerPage?: number;
}

export function buildOwnerVisitsParams(
  query: OwnerVisitsQuery
): Record<string, string> {
  const params: Record<string, string> = {};

  if (query.customPeriod) {
    params.initial_date = query.customPeriod.initial_date;
    params.final_date = query.customPeriod.final_date;
  } else if (query.periodPreset === "all_time") {
    const allTimeRange = getAllTimePeriod(new Date(), query.historyYears);
    params.initial_date = allTimeRange.initial_date;
    params.final_date = allTimeRange.final_date;
  } else {
    params.period = query.periodPreset;
  }

  if (query.propertyId != null) {
    params.property_id = String(query.propertyId);
  }

  if (query.pastPage != null) {
    params.past_page = String(query.pastPage);
  }

  if (query.pastPerPage != null) {
    params.past_per_page = String(query.pastPerPage);
  }

  if (query.upcomingPage != null) {
    params.upcoming_page = String(query.upcomingPage);
  }

  if (query.upcomingPerPage != null) {
    params.upcoming_per_page = String(query.upcomingPerPage);
  }

  return params;
}
